module.exports = __webpack_public_path__ + "static/media/ThumbnailStill16.d6cdd46e.png";